import { Navigate, useTypedParams } from '@sorare/routing';
import { ANY_SPORT_MISSIONS_CATEGORY_RARITY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useMissionsPreferredRarity } from '#src/components/missions/RedirectToMissionsPage/useMissionsPreferredRarity.ts';

import type { PageParams } from './__generated__/routeParams.ts';

const MissionsCategoryPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { category } = useTypedParams<PageParams>();

  const rarity = useMissionsPreferredRarity();

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MISSIONS_CATEGORY_RARITY, {
        params: { category, rarity },
      })}
    />
  );
};

export default MissionsCategoryPage;
